<template>
  <fragment>
    <div
      class="loja-config animate__animated animate__fadeIn animate__delay-0.5s"
    >
      <div class="config-plus">
        <v-container class="px-0 py-4 mb-1">
          <v-row class="mb-2 ml-1 mt-3">
            <h1 class="cookies-text">Taxas - WEB</h1>
          </v-row>
          <v-row>
            <v-divider></v-divider>
          </v-row>
          <v-row class="mt-3">
            <v-col cols="12">
              <label class="input-labels"
                >Valor Mínimo - Taxa de Conveniência</label
              >
              <VuetifyMoney
                hide-details
                v-model="$omnichannel.cadastro.taxa_min_conveniencia"
                solo
                class="textinput"
                placeholder="Insira o valor mínimo"
                :options="options5"
              >
              </VuetifyMoney>
            </v-col>
            <v-col cols="12">
              <label class="input-labels"
                >Porcentagem mínima(%) - Taxa de Conveniência</label
              >
              <v-text-field
                tabindex="5"
                placeholder="0"
                type="number"
                prefix="%"
                solo
                class="textinput"
                v-model="$omnichannel.cadastro.perc_min_conveniencia_web"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <label class="input-labels">Valor Mínimo - Comissão</label>
              <VuetifyMoney
                hide-details
                v-model="$omnichannel.cadastro.comissao_min"
                solo
                class="textinput"
                placeholder="Insira o valor mínimo"
                :options="options5"
              >
              </VuetifyMoney>
            </v-col>
            <v-col cols="12">
              <label class="input-labels"
                >Porcentagem mínima(%) - Comissão
              </label>
              <v-text-field
                tabindex="5"
                placeholder="0"
                solo
                type="number"
                prefix="%"
                class="textinput"
                v-model="$omnichannel.cadastro.perc_min_comissao_web"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
        <v-container class="px-0 py-4 mb-6">
          <v-row class="mb-2 ml-1 mt-0">
            <h1 class="cookies-text">Taxas - POS</h1>
          </v-row>
          <v-row>
            <v-divider></v-divider>
          </v-row>
          <v-row class="mt-3">
            <v-col cols="12">
              <label class="input-labels"
                >Porcentagem mínima(%) - Taxa de Conveniência</label
              >
              <v-text-field
                tabindex="5"
                placeholder="0"
                type="number"
                prefix="%"
                solo
                class="textinput"
                v-model="$omnichannel.cadastro.perc_min_conveniencia_pos"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <label class="input-labels"
                >Porcentagem mínima(%) - Comissão
              </label>
              <v-text-field
                tabindex="5"
                placeholder="0"
                solo
                type="number"
                prefix="%"
                class="textinput"
                v-model="$omnichannel.cadastro.perc_min_comissao_pos"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
        <v-container class="px-0 py-4 mb-8">
          <v-row class="mb-2 ml-1 mt-3">
            <h1 class="cookies-text">Expiração</h1>
          </v-row>
          <v-row>
            <v-divider></v-divider>
          </v-row>
          <v-row class="mt-3">
            <v-col cols="12">
              <div class="d-flex">
                <label class="input-labels">Tempo de expiração do pedido</label>
                <v-tooltip right>
                  <template v-slot:activator="{ on, attrs }">
                    <div
                      class="info-tool d-flex align-center justify-center"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <InfoIcon />
                    </div>
                  </template>
                  <span>Informe o tempo de expiração do pedido em minutos</span>
                </v-tooltip>
              </div>
              <v-text-field
                hide-details
                v-model="$omnichannel.cadastro.exp_pedido"
                solo
                class="textinput"
                placeholder="Insira o tempo de expiração do pedido"
                type="number"
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </div>
      <RegistrationActions :actions="actions" />
    </div>
    <ModalConfirmacao
      :textModal="$omnichannel.text"
      :funcaoModal="$omnichannel.funcao"
      @updateTable="$omnichannel.funcaoRemover"
    />
    <PoliticasAdd />
    <privacyAdd />
    <TermoAdd />
    <TemplatesModal />
  </fragment>
</template>

<script>
import BaseTextField from "@/components/forms/BaseTextField.vue";
export default {
  name: "Store",
  components: {
    // eslint-disable-next-line vue/no-unused-components
    BaseTextField,
    ModalConfirmacao: () => import("@/components/global/modal-confirmacao.vue"),
    PoliticasAdd: () =>
      import(
        "@/components/configuracoes/modal-configuracoes-politica-cookies.vue"
      ),
    privacyAdd: () =>
      import("@/components/configuracoes/politicas-modal-add-edit.vue"),
    TemplatesModal: () =>
      import("@/components/configuracoes/modal-configuracoes-templates.vue"),
    TermoAdd: () =>
      import("@/components/configuracoes/modal-configuracoes-termo-compra.vue"),
    RegistrationActions: () =>
      import("@/components/global/RegistrationActions.vue"),
    InfoIcon: () => import("@/components/icons/InfoIcon.vue"),
    VuetifyMoney: () => import("@/components/global/VuetifyMoney.vue"),
  },
  data() {
    return {
      options5: {
        locale: "pt-BR",
        prefix: "R$",
        suffix: "",
        length: 9,
        precision: 2,
      },
      actions: [
        {
          name: "Salvar",
          action: () => this.$omnichannel.validarCadastro(),
        },
        {
          name: "Cancelar",
          action: () => {
            caches.keys().then(function (names) {
              for (let name of names) caches.delete(name);
            });
            localStorage.removeItem("activeIndex");
            this.$router.push("/home");
            location.reload();
          },
        },
      ],
    };
  },
};
</script>

<style scoped>
.loja-config {
  width: 100%;
  height: 100%;
  align-items: center;
  flex-direction: column;
}
.config-plus {
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: flex-start;
}
.cookies-text {
  font-size: 1em;
  width: 487px;
  align-self: flex-start;
  margin-top: 20px;
}
.info-tool {
  width: 1.25rem;
  height: 1.25rem;
  border-radius: 50px;
  margin-left: 0.625rem;
  cursor: pointer;
}
</style>
